var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"cat"}},[_c('div',{staticClass:"vx-card"},[_c('div',{staticClass:"vx-card__body card-body"},[_c('div',{staticClass:"vx-row"},[_c('div',{staticClass:"vx-col w-full mb-base"},[_c('data-grid',{ref:"grid",attrs:{"stripe":"","data-source":_vm.gridDataSource,"search-data":_vm.gridSearchData,"columns":[
              {
                title: _vm.$t('CostTitle'),
                sort: 'CostTitle',
              },
              { title: _vm.$t('Description'), sort: 'Description' },
              { title: _vm.$t('CreateOn'), sort: 'CreateOn' },
              // { title: $t('Action') },
            ]},scopedSlots:_vm._u([{key:"default",fn:function({ row }){return [_c('td',[_vm._v("\n                "+_vm._s(row.name)+"\n              ")]),_c('td',[_vm._v("\n                "+_vm._s(row.description ? row.description : "-")+"\n              ")]),_c('td',[_vm._v("\n                "+_vm._s(row.createOn)+"\n              ")])]}}])})],1)])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }